import { render, staticRenderFns } from "./side_panel.vue?vue&type=template&id=0b70a006&"
import script from "./side_panel.vue?vue&type=script&lang=coffee&"
export * from "./side_panel.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports